import React from "react";
import PropTypes from "prop-types";
import { Table, Button, Checkbox, Form } from "antd";
import PageContainer from "layout/default-sidebar-layout/PageContainer";
import slug from "constants/slug";
import update from "react-addons-update";
import { autobind } from "core-decorators";
import Breadcrumb from "../breadcrumb";
import createLanguage, { langPropTypes } from "hoc/create-lang";
import OrganizationApi from "api/OrganizationApi";
import menu from "constants/menu";
import { message } from "antd";
import * as _ from "lodash";

const FormItem = Form.Item;
@createLanguage
@autobind
export default class OrganizationRole extends React.Component {
  static propTypes = {
    pagination: PropTypes.object,
    pathImg: PropTypes.string,
    onChangePage: PropTypes.func,
    onChangePageSize: PropTypes.func,
    onDeleteItem: PropTypes.func,
    fetchData: PropTypes.func,
    lang: langPropTypes
  };
  constructor(props) {
    super(props);
    this.state = {
      menu: {},
      dataMenus: [],
      loading: false,
      nameOrganization: ""
    };
  }
  async componentWillMount() {
    this.setState({ loading: true });
    const key = this.props.match.params.key;
    const res = await OrganizationApi.getOne(key);

    let resMenu = {};
    if (res.success) resMenu = res.data.menu ? res.data.menu : {};

    const arr = Object.keys(menu).map(key => ({
      key: key,
      ...menu[key]
    }));

    const arrOrderBy = _.orderBy(arr, ["numericalOrder"], ["asc"]);
    this.setState({
      menu: resMenu,
      dataMenus: arrOrderBy,
      loading: false,
      nameOrganization: res.data.name
    });
  }

  onChangeRule(e, menuName, actionName) {
    this.setState(
      update(this.state, {
        menu: {
          [menuName]: {
            actions: {
              [actionName]: {
                $set: e.target.checked
              }
            }
          }
        }
      })
    );
  }

  onChangeMenu(e, menuName) {
    this.setState({
      menu: {
        ...this.state.menu,
        [menuName]: e.target.checked
          ? {
              actions: {
                view: e.target.checked
              },
              numericalOrder: menu[menuName].numericalOrder,
              description: menu[menuName].description
            }
          : undefined
      }
    });
  }

  async handleSubmit(e) {
    e.preventDefault();
    const key = this.props.match.params.key;

    const arrRoLeSystem = _.keys(menu);
    const dataRoleUpdate = _.keys(this.state.menu);
    // console.log(arrRoLeSystem, this.state.menu, "---dataRoleUpdate---");

    let data = {};
    _.forEach(dataRoleUpdate, item => {
      const index = _.findIndex(arrRoLeSystem, o => {
        return o === item;
      });
      // console.log(index, "--index---");
      if (index > 0 || index === 0) {
        if (this.state.menu[item]) {
          _.set(data, item, {
            key: item,
            ...this.state.menu[item]
          });
        }
      }
    });
    // const data = _.values(_.compact(dataCustom));
    // console.log(data, "---data---");
    // console.log(this.state.menu, "----this.state.menu");

    const res = await OrganizationApi.updateMenu(key, data);
    if (res.success) {
      message.info("Update Rule Organization success!");
      this.props.history.push(slug.organization.list);
    }
    if (res.error) message.info(res.message);
  }

  getColumns() {
    const {
      lang: { t }
    } = this.props;
    return [
      {
        title: t("organization.rule.orderby.label") + " ",
        width: 50,
        render: (text, record, index) => {
          return <strong>{index + 1}</strong>;
        }
      },
      {
        title: t("organization.rule.menu.label"),
        render: (text, record) => {
          return (
            <Checkbox
              key={record.key}
              onChange={e => {
                this.onChangeMenu(e, record.key);
              }}
              checked={
                this.state.menu && this.state.menu[record.key] ? true : false
              }
            >
              {t(`organization.rule.${record.key}.name`)}
            </Checkbox>
          );
        }
      },
      {
        title: t("organization.rule.action.label"),
        render: (text, record) => {
          const actions = _.get(menu, [record.key, "actions"], {});

          const actionsOrganization = _.get(
            this.state,
            ["menu", record.key, "actions"],
            {}
          );
          return (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {Object.keys(actions).map((actionName, index) => {
                if (actionName === "view") return <div />;
                return (
                  <div
                    key={index}
                    style={{
                      paddingBottom: "8px",
                      width: "25%",
                      wordBreak: "initial"
                    }}
                  >
                    {actionName !== "view" && (
                      <Checkbox
                        key={record.key + "_" + actionName}
                        onChange={e => {
                          this.onChangeRule(e, record.key, actionName);
                        }}
                        checked={actionsOrganization[actionName]}
                        disabled={
                          this.state.menu ? !this.state.menu[record.key] : true
                        }
                      >
                        {t(`organization.rule.actions.${actionName}`)}
                      </Checkbox>
                    )}
                  </div>
                );
              })}
            </div>
          );
        }
      }
    ];
  }

  render() {
    // console.log(this.state.dataMenus, "-dataMenus-")
    return (
      <Form onSubmit={this.handleSubmit}>
        <PageContainer>
          <Breadcrumb
            items={[
              "list",
              {
                id: "rule",
                name: this.state.isLoaded ? this.state.nameOrganization : ""
              }
            ]}
          />
          <Table
            rowKey={"key"}
            loading={this.state.loading}
            columns={this.getColumns()}
            dataSource={this.state.dataMenus}
            pagination={{
              pageSize: 1000,
              hideOnSinglePage: true
            }}
          />
          <br />
          <FormItem>
            <Button style={{ width: "100%" }} type="primary" htmlType="submit">
              Save
            </Button>
          </FormItem>
        </PageContainer>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/organization/organization-rule/index.js